import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon.jsx';

const { FiCheck, FiLock, FiShield } = FiIcons;

const Pricing = () => {
  return (
    <section className="py-24 bg-[#2c3a50] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-xl mx-auto">
          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            className="bg-white rounded-[2.5rem] p-10 md:p-14 shadow-2xl border-4 border-[#c5a059] relative"
          >
            <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-[#2c3a50] text-[#c5a059] px-8 py-2 rounded-xl font-bold border-2 border-[#c5a059]">
              INVESTIMENTO ÚNICO
            </div>
            
            <div className="text-center mb-10">
              <h3 className="text-xl font-bold text-[#2c3a50] mb-2 uppercase tracking-widest">Sementinha</h3>
              <p className="text-gray-400 text-[10px] uppercase mb-6 font-bold tracking-widest">Desenvolvimento Emocional Saudável</p>
              <div className="flex flex-col items-center">
                <span className="text-gray-400 line-through text-lg">de R$ 1.997,00</span>
                <div className="flex items-baseline gap-2">
                  <span className="text-6xl font-black text-[#2c3a50]">R$ 997</span>
                </div>
                <p className="text-xl text-[#2c3a50] font-medium mt-2">ou 12x de <span className="font-bold">R$ 99,50</span></p>
              </div>
            </div>

            <div className="space-y-4 mb-10">
              {[
                '15 Módulos com Base Científica',
                'Acesso por 6 Meses ao Conteúdo',
                'Metodologia TCC e Terapia do Esquema',
                'Suporte Prioritário'
              ].map((item, i) => (
                <div key={i} className="flex items-center bg-gray-50 p-4 rounded-xl">
                  <SafeIcon icon={FiCheck} className="w-5 h-5 text-[#c5a059] mr-3 shrink-0" />
                  <span className="text-[#2c3a50] font-bold text-sm tracking-tight">{item}</span>
                </div>
              ))}
            </div>

            <a 
              href="https://pay.kiwify.com.br/IotGhts" 
              className="block w-full bg-[#2c3a50] text-white py-6 rounded-full text-xl font-black text-center hover:bg-[#c5a059] transition-all shadow-xl uppercase mb-6"
            >
              GARANTIR MINHA VAGA
            </a>
            
            <div className="bg-gray-50 rounded-2xl p-6 border border-gray-100 flex flex-col gap-3">
              <div className="flex items-center gap-3 text-[#2c3a50]">
                <SafeIcon icon={FiShield} className="w-5 h-5 text-[#c5a059]" />
                <span className="text-xs font-bold uppercase tracking-tighter">Pagamento Seguro & Garantido</span>
              </div>
              <p className="text-[11px] text-gray-500 leading-relaxed font-medium">
                Seu pagamento é processado pela <b>Kiwify</b>, uma das maiores e mais seguras plataformas de ensino do Brasil. Dados protegidos com criptografia SSL e acesso enviado <b>instantaneamente</b> para seu e-mail após a aprovação do cartão ou Pix.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;